import { render, staticRenderFns } from "./scorerecordchecklist.vue?vue&type=template&id=3df8c8ce&scoped=true"
import script from "./scorerecordchecklist.vue?vue&type=script&lang=js"
export * from "./scorerecordchecklist.vue?vue&type=script&lang=js"
import style0 from "./scorerecordchecklist.vue?vue&type=style&index=0&id=3df8c8ce&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8c8ce",
  null
  
)

export default component.exports